import { render, staticRenderFns } from "./ch_online.vue?vue&type=template&id=20db7a28&"
import script from "./ch_online.vue?vue&type=script&lang=js&"
export * from "./ch_online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports